import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, filter, switchMap, take, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { ManageCartsActions } from '../actions';
import { ActiveCartResponse, SetActiveCartParamsObject } from '../state/cart-details.state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { SharedActions } from '../../../../SGRE-shared/store/shared-store/actions';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { Store } from '@ngrx/store';
import { RouteCheck } from '../../../../SGRE-shared/constants/app-constant';

@Injectable()
export class ActiveCartEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
    private storageService: StorageService,
    private store: Store,
  ) { }

  // Api Call : To Set an Active Cart From the Saved carts List
  setActiveCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ManageCartsActions.setActiveCartCall),
      filter(({ cartId, params }) => !!cartId && !!params),
      switchMap(({ cartId, params }: { cartId: string, params: SetActiveCartParamsObject }) => {
        return this.apiService.setActiveCart(cartId, params)
          .pipe(
            concatMap((response: ActiveCartResponse) => {
              if (response.status !== 201) {
                return of(null);
              }

              if (params.legalEntityId !== this.storageService?.defaultLegalEntity?.uid) {
                this.globalService._updateLegalEntity(params.legalEntityId)
              } else {
                const paramsObject = {
                  legalEntities: params.legalEntityId,
                  fields: 'FULL',
                  currentPage: 0,
                  pageSize: 5
                };

                // Dispatch the action to load Mini Carts GET API
                this.store.dispatch(SharedActions.loadCartsByLegalEntity(paramsObject));
              }
              return of(response);
            }),
            concatMap((response: ActiveCartResponse) => {
              if (response?.status === 201) {
                // Wait for the success action of the Mini Carts GET API call.
                return this.actions$.pipe(
                  ofType(SharedActions.loadCartsByLegalEntitySuccess),
                  tap(() =>
                    this.globalService.checkAndTriggerPageActions([
                      RouteCheck.IS_HOME_PAGE,
                      RouteCheck.IS_PLP,
                      RouteCheck.IS_PDP,
                      RouteCheck.IS_MANAGE_CART,
                      RouteCheck.IS_CART
                    ])
                  ),
                  switchMap(() => of(ManageCartsActions.setActiveCartSuccess({ success: true }))),
                  take(1)
                );
              } else {
                return of(ManageCartsActions.setActiveCartFailure({ error: tryNormalizeHttpError(new Error('Set Active Cart APi failed'), this.logger) }));
              }
            }),
            catchError((error) => {
              console.log('setActiveCart API error:', error);
              return of(ManageCartsActions.setActiveCartFailure({ error: tryNormalizeHttpError(error, this.logger) }));
            })
          );
      })
    )
  );
}